import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../store/actions";
import { useHistory } from "react-router";
import config from "appconfig";
import { clearData } from "store/utils/actions";
import { removeNotificationSubscriber } from "utils/api";

const Logout = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { cognito } = config;

  const handleCognitoLogout = useCallback(() => {
    const url =
      `${cognito.domain}/logout?state=${cognito.state}` +
      `&client_id=${cognito.clientId}&redirect_uri=${cognito.redirectUrl}` +
      `&response_type=code`;
    window.location.replace(url);
  }, [cognito]);

  const handleRemoveSubscribe = useCallback(
    () => removeNotificationSubscriber(localStorage.getItem("b2c:deviceToken")),
    []
  );

  useEffect(() => {
    handleRemoveSubscribe();
    handleCognitoLogout();
    dispatch(logoutUser(history));
    dispatch(clearData());
  });

  return <></>;
};

export default Logout;
